import React from "react";
import { Layout } from "antd";
const { Footer } = Layout;

const FooterLayout = () => {
  return (
    <Footer style={{ textAlign: "center" }}>Powered By Forza Dijital</Footer>
  );
};

export default FooterLayout;
